import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=15024c46&scoped=true&"
import script from "./InfoTooltip.vue?vue&type=script&lang=js&"
export * from "./InfoTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15024c46",
  null
  
)


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports